import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2023 Omer Shaikh. All rights received.
    </footer>
  );
};

export default Footer;
